<script setup lang="ts">
  const version = __APP_VERSION__
  import svg from '@/assets/images/rain.svg'
</script>

<template>
  <div class="relative min-h-144 h-screen">
    <div class="bg-auth"></div>
    <div class="absolute inset-0 flex-center">
      <div class="card max-w-[calc(100vw-48px)] w-sm">
        <div class="block rounded-full p-1 overflow-hidden mx-auto w-24 bg-white h-24 shadow-lg -mb-12 -translate-y-12">
          <div class="rounded-full p-1 flex-center bg-primary size-full">
            <img
              :src="svg"
              alt="logo msshop">
          </div>
        </div>

        <app-router-view />
      </div>
    </div>
    <div class="absolute text-xs text-center text-white inset-x-0 bottom-4">
      v{{ version }}. &copy;2025{{ new Date().getFullYear() === 2025 ? '' : '-' + new Date().getFullYear() }}
      <a
        href="http://gradin.co.id"
        target="_blank"
        class="text-gray-200 hover:underline px-1"
        rel="noopener noreferrer">
        RAIN Boutique
      </a>
    </div>
  </div>
</template>

<style scoped>
  .bg-auth {
    background-image: url("@/assets/images/bg-auth.jpg");
    background-size: cover;
    background-position: center;
    position: fixed;
    inset: 0;
  }
</style>
